export interface HeartDiseaseInterface {
	id: number;
	name: string;
	image_url?: string;
}

export const HeartDiseaseTypes: HeartDiseaseInterface[] = [
	{
		id: 1,
		name: 'Jantung Konorer',
		image_url: '/images/resiko_jantung/jantung-konorer.jpg',
	},
	{
		id: 2,
		name: 'Gagal Jantung',
		image_url: '/images/resiko_jantung/gagal-jantung.jpg',
	},
	{
		id: 3,
		name: 'Tekanan Darah Tinggi',
		image_url: '/images/resiko_jantung/tekanan-darah-tinggi.jpg',
	},
	{
		id: 4,
		name: 'Kolesterol Tinggi',
		image_url: '/images/resiko_jantung/kolesterol-tinggi.jpg',
	},
];
